import { z } from "zod";

export const createOrganisationSchema = z.object({
  name: z.string().min(1, "Organisation name is required"),
  tax_id: z.string().nullable().optional(),
  headquarters_country: z.string().nullable().optional(),
});

export type CreateOrganisationData = z.infer<typeof createOrganisationSchema>;
